import { EmployersEdit } from './EmployersEdit';
import { EmployersFilter } from './EmployersFilter';
import { EmployersList } from './EmployersList';
import { EmployersShow } from './EmployersShow';

export const list = EmployersList;
export const edit = EmployersEdit;
export const show = EmployersShow;
export const filter = EmployersFilter;
